// @ts-nocheck
import { schGeoListingsFilters } from '@aloft/toolkit-shared';

import { useWatch } from 'react-hook-form';
import { z } from 'zod';

export const countActiveFilters = (
  filters: ReturnType<typeof useWatch<z.input<typeof schGeoListingsFilters>>>,
): number => {
  return Object.values(filters).reduce((acc: number, val) => {
    if (typeof val === 'string' && val.length > 0) {
      return acc + 1;
    } else if (typeof val === 'object') {
      if (val.min || val.max || val.variance || val.percentage || val.exact) {
        return acc + 1;
      }
    } else if (typeof val === 'boolean') {
      return acc + 1;
    }
    return acc;
  }, 0);
};
